var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-main",attrs:{"id":"app"}},[_c('Header'),(!_vm.isMobile)?_c('Desktop'):_vm._e(),(_vm.$store.state.loading)?_c('Loading'):_vm._e(),_c('main',[(_vm.isMobile)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }